<template>
  <div
    class="emptyGridMsgSec"
    v-if="lstProduct == null && lstProduct.length == 0"
  >
    <i class="mdi mdi-note-outline"></i>
    <h3>No Record Found</h3>
    <p class="text-muted">
      We didn't find anything to show here, please add new data
    </p>
  </div>
  <!-- v-if="lstProduct.length > 0" -->
  <div v-if="lstProduct != null && lstProduct.length > 0">
    <DataTable
      class="table-responsive"
      v-model:filters="filters"
      :value="lstProduct"
      paginator
      :rows="5"
      :rowsPerPageOptions="[5, 10, 20, 50]"
      stripedRows
      virtualScroller
      tableStyle="min-width: 50rem"
      responsive
      style="overflow-x: hidden"
    >
      <!-- scrollHeight="400px" -->
      <template #header>
        <div class="row justify-content-between">
          <div class="col-4">
            <BFormInput
              id="inline-form-input-name"
              class="form-control form-control-lg"
              placeholder="Search"
              v-model="filters['global'].value"
            />
          </div>
          <!-- <div class="col-4">
            <a
              class="btn btn-block btn-lg btn-gradient-primary"
              style="float: right"
              @click="exportToCSV($event)"
              ><i class="mdi mdi-export"></i> Export</a
            >
          </div> -->
        </div>
      </template>
      <template #empty> No data found. </template>

      <Column header="Sr. no" headerStyle="width:3rem">
        <template #body="slotProps">
          {{ slotProps.index + 1 }}
        </template>
      </Column>

      <Column
        v-for="col of columns"
        :key="col.field"
        :field="col.field"
        :header="col.header"
        sortable
      ></Column>
      <!-- <Column field="prn_release_date" header="Last Release Date" sortable>
        <template #body="slotProps">
          {{ formatDateTime(slotProps.data.prn_release_date) }}
        </template>
      </Column> -->
      <Column field="prd_status" header="Status" sortable>
        <template #body="slotProps">
          <span
            :class="[
              slotProps.data.prd_status == 0
                ? 'badge badge-gradient-danger'
                : 'badge badge-gradient-success',
            ]"
            style="font-size: 0.875rem"
          >
            {{ slotProps.data.prd_status == 1 ? "Active" : "Deactive" }}
          </span>
        </template>
      </Column>
      <Column header="Certificates" style="width: 10%; min-width: 8rem">
        <template #body="slotProps">
          <a
            class="btn-grid-action"
            data-bs-toggle="Click to Download"
            title="View Certificates"
            @click="openModal(slotProps.data)"
          >
            <i class="mdi mdi-certificate mdi-24px"></i>
          </a>
        </template>
      </Column>
    </DataTable>
  </div>
  <DynamicDialog />
</template>

<script setup>
/* eslint-disable */
import { onMounted, ref, defineAsyncComponent } from "vue";
import DynamicDialog from "primevue/dynamicdialog";
import axios from "axios";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { FilterMatchMode } from "primevue/api";
// import { format } from "date-fns";
import { useAuthStore } from "@/store/auth_store";
import { useDialog } from "primevue/usedialog";
import { useLoading } from "vue-loading-overlay";
import { toast } from "vue3-toastify";

const product_certificate = defineAsyncComponent(() =>
  import("./manage-product-certificate.vue"),
);

const $loading = useLoading();
const auth_store = useAuthStore();
const lstProduct = ref([]);
const dialog = useDialog();

onMounted(() => {
  fetchProdctList();
});

const columns = ref([
  { field: "prd_name", header: "Product Name" },
  { field: "prd_product_line", header: "Product Line" },
  //   { field: "prn_created_by", header: "Latest Version Released By" },
  { field: "prn_firmware", header: "Latest Firmware" },
  { field: "prn_version", header: "Latest Version" },
  //   { field: "prn_release_date", header: "Last Released On" },
]);

const filters = ref({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
});

function fetchProdctList() {
  const loader = $loading.show({
    // Optional parameters
  });
  axios
    .post("/fetch_products")
    .then((res) => {
      loader.hide();
      if (res.data != null && res.data.length > 0) {
        lstProduct.value = res.data;
      }
    })
    .catch((err) => {
      loader.hide();
      toast(err.response.data.detail, {
        autoClose: 2000,
        theme: "colored",
        type: "error",
        position: "bottom-left",
        dangerouslyHTMLString: true,
      });
    });
}

const openModal = (selectedProduct) => {
  const dialogRef = dialog.open(product_certificate, {
    props: {
      header: selectedProduct.prd_name + " Certificates",
      style: {
        width: "70vw",
      },
      breakpoints: {
        "960px": "75vw",
        "640px": "90vw",
      },
      modal: true,
    },
    data: {
      selectedProduct: selectedProduct,
    },
    // templates: {

    // },
    onClose: (options) => {
      let closeaction = true;
    },
  });
};
</script>
